import { Task } from 'taskarian';
import { callApi } from '../../../../../Appy';
import { findLinkByT } from '../../../../../Links';
import { Link } from '../../../../../Resource/Types';
import { collaboratorAccessResourceDecoder } from './Decoders';
import CollaboratorAccessStore from './Store';
import { CollaboratorAccessResource, Draft } from './Types';

// Groups only travel with 'client-groups'; the server clears the join for
// any other choice, matching what the Builder v1 Share step sends.
const encode = (draft: Draft) => ({
  collaborator_access: {
    permission_type: draft.permissionType,
    client_groups: draft.permissionType === 'client-groups' ? draft.clientGroupIds : [],
  },
});

export const loadCollaboratorAccess = (link: Link, store: CollaboratorAccessStore): void => {
  Task.succeed<{}, Link>(link)
    .andThen(callApi(collaboratorAccessResourceDecoder, {}))
    .fork(() => store.loadFailed(), store.loaded);
};

export const saveCollaboratorAccess = (
  resource: CollaboratorAccessResource,
  draft: Draft,
  store: CollaboratorAccessStore,
): void => {
  Task.succeed<{}, ReadonlyArray<Link>>(resource.links)
    .andThen(findLinkByT({ rel: 'update', method: 'put' }))
    .andThen(callApi(collaboratorAccessResourceDecoder, encode(draft)))
    .fork(
      () => store.saveFailed(),
      () => store.saved(),
    );
};
